import { FileAlertOutlineIcon } from './FileAlertOutlineIcon';

/**
 * author: Simran
 * id 0FF64B42-C9F6-4A0A-B09D-38D2AED8C81C
 * name file-alert-outline
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-alert-outline.svg
 * tags
 * - Files / Folders 
 * - Alert / Error 
 */
export const FileWarningOutlineIcon = FileAlertOutlineIcon;
export default FileWarningOutlineIcon